<template>
    <div> 
        <div class="splash-screen">
            <header class="cabecera">
                <small class="subtitulo">
                    <strong>Sistema de Información Geográfico</strong>
                </small>
                <h1 class="subtitulo">
                    <span>Modulo de Seguridad</span>
                </h1>
                </header>            
            <div class="card-body">
				<form>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><i class="fas fa-user"></i></span>
						</div>
						<input type="text" class="form-control" placeholder="Usuario" v-model="usuario" required>						
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><i class="fas fa-key"></i></span>
						</div>
						<input type="password" class="form-control" placeholder="Contraseña" v-model="password" required>
					</div>
					<div class="form-group">
                        <div class="row">
                            <div class="col">
                                <button  type="button"  class="btn btn-primary"  style=" width: 100%;" @click="login" >Ingresar</button>
                            </div> 
                            <div class="col">
                                <button  type="button"  class="btn btn-primary"  style=" width: 100%;" @click="closeLoginScreen" >Salir</button>
                            </div>               
                        </div>
					</div>
				</form>
			</div>          
            
            <section>
            </section>
            <footer class="footer">
            </footer>
        </div>
        <div class="sombra"></div>
    </div>

</template>

<script>
    import {arcgisConfig} from "../config";
    import {xmlListToJson, getWebServiceSoap, xml2json} from "@/helpers/xmlhelper";

    const config = splash_config;
    export default {
        name: "LoginScreen",
        data:function(){
            return{
                usuario:"",
                password:"",
                error:false,
                err_msg:"",
            }
        },
        methods:{
            async login(){
                let options={};
                options.titulo = 'Validación de Usuario';
                options.iconClass = 'message-icon-error';
                options.subtitulo = '';
                let m_sOpcExec= "1";
				let m_nPassword="";
				let m_iNroIntentos=0;
				let m_iFlgCambiaPwd=0;

                //--validamos el usuario y contraseña
                if(this.usuario.length == 0)  {
                    options.subtitulo = "Usted debe Ingresar un Usuario";
                    this.$emit('AppShowMessage', options);
                    return
                }
                if(this.password.length == 0) {
                    options.subtitulo = "Usted debe Ingresar una Contraseña";
                    this.$emit('AppShowMessage', options);
                    return
                }
                //Invocamos al WebService que Valida al Usuario
                const urlWs = arcgisConfig.WS_SIGLOG + "/WSSIGLOGIN_LISTA_USUARIO";
                const WsParam = `STR_OPCION=${m_sOpcExec}&STR_USUARIO=${this.usuario}&STR_PASSWORD=${this.password}&NUM_INTENTOS=${m_iNroIntentos}&FLAG_PASSWORD=${m_iFlgCambiaPwd}&NEW_PASSWORD=${m_nPassword}}&CNEW_PASSWORD=${m_nPassword}`
                const xmlTextPOST = await getWebServiceSoap(urlWs, WsParam);
                const WsResult = xml2json(xmlTextPOST);
                if (WsResult.STR_WS_STATUS == 0){
					if (WsResult.STR_COD_LOGIN=='0'){
						//Ingresa al Sistema OK y cerramos la Formulario
                        this.$globalVar.APP_USER_CONNECT = this.usuario;
                        this.closeSplashScreen();
					}else{
						//Evaluamos los Posibles 
                        this.showErrorLogin(WsResult.STR_COD_LOGIN, WsResult.STR_MSG_LOGIN);                       
					}
                }

            },
            showErrorLogin(item, message){
                let options={};
                options.titulo = 'Ingreso al Sistema';
                options.subtitulo = '';

				switch (item){
					case '-1':{
                        options.subtitulo = "Contraseña cambiada exitosamente.";
                        this.$emit('AppShowMessage', options);
                        return}
						//txtContrasena.text=m_nPassword;
						//onCancelar();
					case '0':{
                        options.subtitulo = "Contraseña cambiada exitosamente.";
                        this.$emit('AppShowMessage', options);
                        return}
					case '1':{
                        options.subtitulo = "Contraseña ya existe.\n\n" + 
							                "Su Contraseña no debe ser igual a ninguna de sus 3 contraseñas anteriores, " + 
							                "escriba otra contraseña que cumpla con estos requisitos en ambos cuadros de texto"
                        this.$emit('AppShowMessage', options);
                        return}				
					case '2':{
                        options.subtitulo = "El Usuario Ingresado No Existe."							                
                        this.$emit('AppShowMessage', options);
                        return}	                        
					case '3':{
                        options.subtitulo = "Contraseña incorrecta.\n\n" + 
                                            "La contraseña ingresada debe coincidir con la actualmente registrada " + 
                                            "tomando en cuenta las letras mayúsculas y minúsculas, soló se permiten " + 
                                            "letras y/o números."
                        this.$emit('AppShowMessage', options);
                        return}
					case '4':{
                        options.subtitulo = "El Usuario está deshabilitado\n" + 
							                "contactese con su Administrador Para su Activacion"
                        this.$emit('AppShowMessage', options);
                        return}
					case '5':{
                        options.subtitulo = "El Usuario está Suspendido.\n" + 
							                "contactese con su Administrador Para su Activacion"
                        this.$emit('AppShowMessage', options);
                        return}
					case '6':{
                        options.subtitulo = "El Usuario está bloqueado.\n" + 
							                "contactese con su Administrador Para su Desbloqueo"
                        this.$emit('AppShowMessage', options);
                        return}				
					case '7':{
                        options.subtitulo = "Por favor cambie su clave.\nPor ser esta su primera sesión."
                        this.$emit('AppShowMessage', options);
                        //onCambiaPwd();
                        return}	                        
					case '8':{
						//Numero de Dias que caduca la Contrasena
                        options.subtitulo = "Su clave caduca en " + message + " dia(s).\n ¿Desea cambiar de clave ahora?"
                        this.$emit('AppShowMessage', options);
                        return}
					case '9':{
                        options.subtitulo = "Por favor cambie su clave.\n Por ya haber caducado."
                        this.$emit('AppShowMessage', options);
                        //onCambiaPwd();
                        return}
					case '10':{
                        options.subtitulo = "Ha sobrepasado el número de días permitidos por inactividad.\n" +
							                "Su Código de Usuario sera deshabilitado"
                        this.$emit('AppShowMessage', options);
                        return}
					case '11':{
                        options.subtitulo = "Ha sobrepasado el número de intentos permitidos.\n" +
							                "Su código de usuario sera bloqueado."
                        this.$emit('AppShowMessage', options);
                        return}						
					default:{
						//Error de Logueo
                        options.subtitulo = item + ':' +message
                        this.$emit('AppShowMessage', options);
                        return}						
                }
            },
            closeLoginScreen(){
                this.$emit('AppCloseWindow');
            },
            closeSplashScreen(){
                this.$emit('close');
            },         
        }
    }
</script>

<style scoped>
    .splash-screen {
        width: 25%;
     }
     
    .row{
        width: 100%;
        margin-top: 5px;
        display:flex;
    }
    .col{
        flex-grow: 1;
        margin-right: 0.5em;
    }
    .col:last-child{
        margin-right: 0;
    }
</style>
